module.exports = __webpack_public_path__ + "img/LDSJ_STILL4.10f18905.jpg";